export const LOG_LEVEL = {
  NONE: 'NONE',
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  TRACE: 'TRACE'
} as const;

export type LogLevel = keyof typeof LOG_LEVEL;
